import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Pp360RadioComponent } from './pp360-radio.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [Pp360RadioComponent],
  imports: [CommonModule, FormsModule],
  exports: [Pp360RadioComponent]
})
export class Pp360RadioModule {}
